import { visitAsyncGetters } from '../../visit/visit.asyncGetters';
import * as Duo from '../../duo';
import { duoAsyncGetters } from 'src/replicant/duo/duo.asyncGetters';
import { giftsAsyncGetters } from 'src/replicant/gifts/gifts.asyncGetters';
import { match2TournamentsAsyncGetters } from 'src/replicant/match2/tournament/match2-tournament.asyncgetters';
import { leaguesAsyncGetters } from 'src/replicant/match2/leagues/leagues.asyncgetters';
import { teamAsyncGetters } from 'src/replicant/team/team.asyncGetters';
import { airtableAsyncGetters } from 'src/replicant/airtable/airtable.asyncGetters';
import { iapAsyncGetters } from 'src/replicant/iap/iap.asyncGetters';
import { cardsAsyncGetters } from 'src/replicant/cards/cards.asyncGetters';
import { friendsAsyncGetters } from 'src/replicant/friends/friends.asyncGetters';
import { friendSuggestionsAsyncGetters } from 'src/replicant/friends/friendSuggestions.asyncGetters';
import { socialAsyncGetters } from 'src/replicant/social/social.asyncGetters';
import { weeklyLeaderboardAsyncGetters } from 'src/replicant/weeklyLeaderboard/weeklyLeaderboard.asyncGetters';
import { guestAsyncGetters } from 'src/replicant/guest/guest.asyncGetters';
import { profileAsyncGetters } from 'src/replicant/profile/profile.asyncGetters';
import { buddiesAsyncGetters } from 'src/replicant/buddies/buddies.asyncGetters';
import { chatbotAsyncGetters } from 'src/replicant/chatbot/chatbot.asyncGetters';

export default {
  ...visitAsyncGetters,
  ...duoAsyncGetters,
  ...match2TournamentsAsyncGetters,
  ...leaguesAsyncGetters,
  ...teamAsyncGetters,
  ...airtableAsyncGetters,
  ...giftsAsyncGetters,
  ...iapAsyncGetters,
  ...cardsAsyncGetters,
  ...friendsAsyncGetters,
  ...friendSuggestionsAsyncGetters,
  ...socialAsyncGetters,
  ...weeklyLeaderboardAsyncGetters,
  ...guestAsyncGetters,
  ...profileAsyncGetters,
  ...buddiesAsyncGetters,
  ...chatbotAsyncGetters,
};
